import { RestService } from "./RestService";

export class ScheduledVoucherTypeService extends RestService {
    constructor() {
        super("/api/v1/scheduled_voucher_types");
    }
}
